import React, { useEffect, useState } from 'react'
import { GetById_Category_Api, Update_Category_Api, GetAll_Category_Api } from '../../API/CategoryApi';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';
// =================================================================
const { Option } = Select;

export const EditCategoryComponent = ({ id, setLoading, showMessage, rowUpdated, cancelEdit }) => {
    // =================================================================
    const [category, setCategory] = useState(null);
    const [parentId, setParentId] = useState(null);
    const [form] = Form.useForm();
    const [parentOptions, setParentOptions] = useState([]); // لیست والدها برای Select

    // =================================================================
    useEffect(() => {
        if (id != null) {
            loadParentOptions();
            loadData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // =================================================================
    const loadParentOptions = async () => {
        try {
            // فرض: این API لیست تمام دسته‌ها را برمی‌گرداند
            const res = await GetAll_Category_Api();
            if (res && res.messageStatus === "Successful") {
                // فیلتر: خودِ آیتم فعلی را در لیست والدها نگذاریم تا از انتخاب خودش جلوگیری شود
                const items = res.messageData.data || [];
                const options = items
                    .filter(it => it.id !== id) // جلوگیری از انتخاب خودش به عنوان والد
                    .map(it => ({ value: it.id, label: it.title }));
                setParentOptions(options);
            } else {
                // اگر خطا وجود داشت، می‌توانیم پیام دهیم ولی نباید کار اصلی را شکست دهیم
                // showMessage(res.message ?? "خطا در دریافت لیست والدها", "error");
            }
        } catch (err) {
            // showMessage("خطا در دریافت لیست والدها", "error");
        }
    };

    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_Category_Api(id);
            setLoading(false);
            if (data && data.messageStatus === "Successful") {
                const cat = data.messageData.data;
                setCategory(cat);
                setParentId(cat.parentId ?? null);
                // مقداردهی فرم (شامل parentId)
                form.setFieldsValue(cat);
            } else {
                showMessage(data?.message ?? "خطا در دریافت اطلاعات", "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }

    // =================================================================
    const onSubmit = async (values) => {
        try {
            setLoading(true);
            values.id = id;
            // اگر فرم parentId ندارد یا خالی است، از state استفاده کن؛ در نهایت اگر خالی بود 0 قرار بده  
            if (values.parentId === undefined || values.parentId === null) {  
                values.parentId = parentId ?? 0;  
            }  
            // تضمین اینکه اگر هنوز null است، به 0 تبدیل شود  
            if (values.parentId === null) values.parentId = 0;  
            let data = await Update_Category_Api(values);
            setLoading(false);

            if (data && data.messageStatus === "Successful") {
                showMessage(data.message ?? "ذخیره با موفقیت انجام شد", "Successful")
                rowUpdated();
            }
            else {
                showMessage(data?.message ?? "خطا در ذخیره", "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };

    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };

    // =================================================================
    // وقتی کاربر والد را در Select تغییر می‌دهد، state و فرم را هم آپدیت می‌کنیم
    const handleParentChange = (value) => {
        setParentId(value ?? null);
        form.setFieldsValue({ parentId: value ?? null });
    };

    // =================================================================
    return (
        <>
            {category ? (
                <>
                    <div className='sectionTitle'>
                        <h2>
                            ویرایش {category.title}
                        </h2>
                    </div>
                    <div className='container'>
                        <Form
                            form={form}
                            name="basic"
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item
                                name="title"
                                label="عنوان"
                                rules={[{ required: true, message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input placeholder='عنوان' />
                            </Form.Item>

                            <Form.Item
                                name="comment"
                                label="شرح"
                            >
                                <Input placeholder='شرح' />
                            </Form.Item>

                            {/* کنترل انتخاب والد */}
                            <Form.Item
                                name="parentId"
                                label="والد"
                            >
                                <Select
                                    allowClear
                                    placeholder="انتخاب والد (در صورت وجود)"
                                    onChange={handleParentChange}
                                    value={parentId}
                                    showSearch
                                    optionFilterProp="children"
                                >
                                    <Option value={null} key="none">بدون والد</Option>
                                    {parentOptions.map(opt => (
                                        <Option value={opt.value} key={opt.value}>
                                            {opt.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            {/* مخفی برای تضمین ارسال در payload */}
                            <Form.Item
                                name="id"
                                hidden={true}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="showInPeriod"
                                label="نمایش در دوره های رزرو"
                                valuePropName='checked'
                            >
                                <Checkbox />
                            </Form.Item>

                            <Form.Item
                                name="showInPrice"
                                label="نمایش در قیمت گذاری"
                                valuePropName='checked'
                            >
                                <Checkbox />
                            </Form.Item>

                            <Form.Item
                                name="showInFoodPeriod"
                                label="نمایش در دوره غذایی"
                                valuePropName='checked'
                            >
                                <Checkbox />
                            </Form.Item>

                            <Form.Item
                                name="showInParkingPeriod"
                                label="نمایش در دوره پارکینگ"
                                valuePropName='checked'
                            >
                                <Checkbox />
                            </Form.Item>

                            <Form.Item
                                name="orderIndex"
                                label="ترتیب"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="isActive"
                                label="فعال"
                                valuePropName='checked'
                            >
                                <Checkbox />
                            </Form.Item>
                        </Form>
                    </div>

                    <Row className='sectionFooter' style={{ marginTop: 16 }}>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}






/*import React, { useEffect, useState } from 'react'
import { GetById_Category_Api, Update_Category_Api } from '../../API/CategoryApi';
import { Button, Checkbox, Col, Form, Input, InputNumber, Layout, Row } from 'antd';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
// =================================================================
export const EditCategoryComponent = ({ id, setLoading, showMessage, rowUpdated, cancelEdit }) => {
    // =================================================================
    const [category, setCategory] = useState();
    const [form] = Form.useForm()
    // =================================================================
    useEffect(() => {
        loadData();
    }, [id]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_Category_Api(id);
                setLoading(false);
                if (data.messageStatus == "Successful") {
                setCategory(data.messageData.data);
                form.setFieldsValue(data.messageData.data);
            }
            else {
                showMessage(data.message, "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
        try {
            setLoading(true);
            values.id = id;
            let data = await Update_Category_Api(values);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful")
                rowUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // =================================================================
    return (
        <>
            {category ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {category.title}
                        </h2>
                    </div>
                    <div className='container'>
                    <Form
                        form={form}
                        name="basic"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 20 }}
                        onFinish={onSubmit}
                        onFinishFailed={onFinishFailed}
                    >
                        <Form.Item
                            name="title"
                            label="عنوان"
                            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                        >
                            <Input placeholder='عنوان' />
                        </Form.Item>

                        <Form.Item
                            name="comment"
                            label="شرح"
                            rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                        >
                            <Input placeholder='شرح' />
                        </Form.Item>

                        <Form.Item
                            name="parentTitle"
                            hidden={true}
                        >
                        </Form.Item>
                        <Form.Item
                            name="id"
                            hidden={true}
                        >
                        </Form.Item>

                        <Form.Item
                            name="showInPeriod"
                            label="نمایش در دوره های رزرو"
                            valuePropName='checked'
                        >
                            <Checkbox checked={category.showInPeriod}> </Checkbox>
                        </Form.Item>

                        <Form.Item
                            name="showInPrice"
                            label="نمایش در قیمت گذاری"
                            valuePropName='checked'
                        >
                            <Checkbox checked={category.showInPrice}> </Checkbox>
                        </Form.Item>

                        <Form.Item
                            name="showInFoodPeriod"
                            label="نمایش در دوره غذایی"
                            valuePropName='checked'
                        >
                            <Checkbox checked={category.showInFoodPeriod}> </Checkbox>
                        </Form.Item>

                        <Form.Item
                            name="showInParkingPeriod"
                            label="نمایش در دوره پارکینگ"
                            valuePropName='checked'
                        >
                            <Checkbox checked={category.showInParkingPeriod}> </Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="orderIndex"
                            label="ترتیب"
                        >
                            <InputNumber />
                        </Form.Item>


                        <Form.Item
                            name="isActive"
                            label="فعال"
                            valuePropName='checked'
                        >
                            <Checkbox checked={category.isActive}> </Checkbox>
                        </Form.Item>
                    </Form>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}
    */
